export default "__VITE_ASSET__CN528WTR__"